<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-text>
          <v-text-field
            v-model="form.email"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="form.errors.email"
            :label="$t('Email')"
            outlined
            autofocus
            name="email"
            type="email"
            autocomplete="email"
          />

          <v-autocomplete
            v-model="form.country"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="form.errors.country"
            :label="$t('Country')"
            outlined
            :items="countries"
            item-text="name"
            item-value="code"
            autocomplete="new-password"
          />

          <password-input
            v-model="form.password"
            outlined
            :label="$t('Password')"
            :loading="form.processing"
            :disabled="form.processing"
            :error-messages="form.errors.password"
          />

          <v-checkbox
            v-model="form.terms"
            :error-messages="form.errors.terms"
            :loading="form.processing"
            :disabled="form.processing"
          >
            <div slot="label">
              {{ $t('I accept the') }} <a
                href="https://www.privacypolicies.com/live/520d22cd-0f8d-4638-a0b5-805d2e58e6df"
                target="_blank"
                @click.stop
              >{{ $t('Privacy policy') }}</a> {{ $t('and') }} <a
                href="https://www.webcomet.io/terms.html"
                target="_blank"
                @click.stop
              >{{ $t('Terms of Service') }}</a>
            </div>
          </v-checkbox>

          <!-- <captcha
            :key="captchaKey"
            :site-key="captchaSiteKey"
            @result="handleCaptchaResult"
          /> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            type="submit"
            :loading="form.processing"
            :disabled="form.processing || !form.terms"
            color="primary"
          >
            {{ $t('Register') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import { Link } from '@inertiajs/vue2';
import Layout from '@/components/auth/Layout';
import PasswordInput from '../../components/shared/PasswordInput.vue';

export default {
  components: { PasswordInput },

  layout: (h, page) => h(Layout, {
    props: {
      title: i18n.t('Register an account')
    },
    scopedSlots: {
      bottom: () => {
        const loginLink = h(Link, {
          class: {
            'mt-4': true
          },
          style: {
            zIndex: '1'
          },
          props: {
            href: window.route('login'),
          }
        }, i18n.t('Already have an account? Login'));

        return loginLink;
      }
    }
  }, [page]),

  props: {
    countries: {
      type: Array,
      required: true
    },
    captchaSiteKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        country: '',
        password: '',
        captcha: '',
        terms: false
      }),
      captchaKey: 0,
    }
  },

  methods: {
    submit() {
      this.form.post(`${this.route('register')}${location.search}`, {
        preserveScroll: true,
        onError: () => {
          this.captchaKey++;
        }
      });
    },

    handleCaptchaResult(token) {
      this.form.captcha = token;
    },

    setTeamName() {
      if (!this.form.name) return;

      this.form.team_name = `${this.form.name.split(' ', 2)[0]}'s Team`;
    }
  }
}
</script>